import { ARGS_DESCRIPTIONS, MEDIA_TYPES } from '@repo/network'
import { ChatTemplateHeaderType, ComponentMessageMediaVO } from '@repo/types'
import { normalize } from '@repo/db'

type ReturnValueForEachKey = {
  name?: string
  owner?: string
  dealer?: string
}

export const getValueByDescription = (description: string, values: ReturnValueForEachKey) => {
  const key = findDescriptionKey(description)
  switch (key) {
    case 'NAME':
      return values.name
    case 'OWNER':
      return values.owner
    case 'DEALER':
      return values.dealer
    default:
      return undefined
  }
}

export const headerTypeByMediaType = (mediaType?: string): ChatTemplateHeaderType | undefined => {
  if (!mediaType) {
    return undefined
  } else if (mediaType.includes('image')) {
    return ChatTemplateHeaderType.MEDIA_IMAGE
  } else if (mediaType.includes('video')) {
    return ChatTemplateHeaderType.MEDIA_VIDEO
  } else {
    return ChatTemplateHeaderType.MEDIA_DOCUMENT
  }
}

export const createChatTemplateHeader = (text?: string | null, medias?: ComponentMessageMediaVO[] | null) => {
  return {
    text: text ?? undefined,
    media: firstMedia(medias),
    type: headerTypeByMediaType(firstMedia(medias)?.mediaType)
  }
}

export const findDescriptionKey = (description: string) => {
  return Object.entries(ARGS_DESCRIPTIONS)
    .map(([key, descriptions]) => (descriptions.map(it => normalize(it)).includes(description) ? key : undefined))
    .filter(it => it !== undefined)?.[0]
}

export const TEMPLATE_ARG_MAX_LENGTH = 500
export const CLIENT_NAME_ARG_MAX_LENGTH = 255

export const getTemplateArgMaxLength = (description?: string) => {
  if (!description) {
    return TEMPLATE_ARG_MAX_LENGTH
  }
  return findDescriptionKey(normalize(description)) === 'NAME' ? CLIENT_NAME_ARG_MAX_LENGTH : TEMPLATE_ARG_MAX_LENGTH
}

export const mediaTypeByType = (mediaType?: string) => {
  if (!mediaType) {
    return undefined
  } else if (mediaType.includes('image')) {
    return MEDIA_TYPES.MEDIA_IMAGE
  } else if (mediaType.includes('video')) {
    return MEDIA_TYPES.MEDIA_VIDEO
  } else if (mediaType.includes('audio')) {
    return MEDIA_TYPES.MEDIA_AUDIO
  } else {
    return MEDIA_TYPES.MEDIA_DOCUMENT
  }
}

export const firstMedia = (medias?: ComponentMessageMediaVO[] | null) => {
  return medias?.[0]
}
